import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { VideoStudiosContext, IVideoStudiosContext } from '../../../videoStudiosState/videoStudiosContext';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString } = useContext<IVideoStudiosContext>(VideoStudiosContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
